var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"linear"},[(_vm.show)?_c('v-progress-linear',{attrs:{"color":"primary darken-2","height":"4","indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }